(function() {
	'use strict';

	angular
		.module('components')
		.controller('SnapPackageResultComponentController', SnapPackageResultComponentController);

	/**
	 * Our constructor
	 * @constructor
	 * @param {Object} $element Element
	 * @param {Object} $rootScope $rootScope
	 * @param {Service} FeeService Fee Service
	 * @param {Service} Language Language
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilityFunctions Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {self} Our instance
	 * @ngInject
	 */
	function SnapPackageResultComponentController(
		$element,
		$rootScope,
		FeeService,
		Language,
		Utilities,
		UtilityFunctions,
		UtilsValidation
	) {
		var vm = this,
			createEvent = UtilityFunctions.createEvent;

		// PROPERTIES
		vm.image = null;
		vm.showFeeNotice = FeeService.isPageActive(FeeService.enums.SNAP_CALENDAR);
		// METHODS
		vm.$onDestroy = $onDestroy;
		vm.$onInit = $onInit;
		vm.$onChanges = $onChanges;
		vm._ = {
			onClick: createEvent(onClick),
			onKeydown: createEvent(onKeydown)
		};
		vm.customerName = '';

		/**
		 * Called when the component is being destroyed
		 * @public
		 * @returns {undefined}
		 */
		function $onDestroy() {
			$element
				.off('click', vm._.onClick)
				.off('keydown', vm._.onKeydown);
		}

		/**
		 * Called when initializing the component
		 * @public
		 * @returns {undefined}
		 */
		function $onInit() {
			$element
				.attr({
					role: 'group',
					tabindex: '0'
				})
				.addClass('snap-pkg-result gap-row gap-16 focus--mouse cursor')
				.on('click', vm._.onClick)
				.on('keydown', vm._.onKeydown);

			vm.currencyCode = $rootScope.currencyCode;
			vm.languageSettings = $rootScope.languageSettings;
		}
		/**
		 * Called when attributes change
		 * @public
		 * @param {Object} changes The changes object
		 * @returns {undefined}
		 */
		function $onChanges(changes) {
			var customerName = '';
			if (changes.pkgImage) {
				vm.image = UtilsValidation.validString(changes.pkgImage.currentValue) ? $rootScope.getAssetUrl(changes.pkgImage.currentValue) : null;
			}

			if (changes.pkgCustomerName) {
				if (changes.pkgCustomerName.currentValue) {
					customerName = Language.getLocaleWithSuffixAndFallback('SnapCalendar', 'per', '@@MERCHANT_ID').replace('@@type', Utilities.getString(changes.pkgCustomerName.currentValue));
				}

				vm.customerName = customerName;
			}
		}

		/**
		 * Called when the component gets clicked so it triggers and lets the parent know
		 * @private
		 * @returns {undefined}
		 */
		function onClick() {
			if (angular.isFunction(vm.didClick)) {
				vm.didClick({ id: vm.pkgId });
			}
		}

		/**
		 * Called when the component gets keyboard input so it triggers and lets the parent know
		 * @private
		 * @param {Event} $event The event object
		 * @returns {undefined}
		 */
		function onKeydown($event) {
			var code = $event.code || $event.keyCode || $event.which;

			if (angular.isFunction(vm.didClick) && ['Enter', 13].includes(code)) {
				vm.didClick({ id: vm.pkgId });
			}
		}
	}
}());